import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["emailAccounts"]

  static values = { billingCycle: String, level: String }

  updateFrame() {
    let emailAccountsFrame = document.getElementById("checkout_edit_email_accounts")
    emailAccountsFrame.src = `/subscriptions/checkout/email_accounts?billing_cycle=${this.billingCycleValue}&level=${this.levelValue}&email_accounts=${this.emailAccountsTarget.value}`
    emailAccountsFrame.reload()
  }
}
